import useAccount from '~/composables/auth/useAccount'
import { sendLogin } from '~/composables/useGtmEvents'

export default function useAuth() {
  const router = useRouter()
  const localePath = useLocalePath()
  const isAuthenticated: Ref<boolean> = useState('isAuthenticated', () => false)

  const { fetchProfile, cleanProfile, user } = useAccount()

  async function login(email: string, password: string) {
    await $fetch('/api/auth/login/', {
      method: 'POST',
      body: { email, password },
    })

    await fetchProfile()
    sendLogin('form', user.value?.data?.id || null)
    isAuthenticated.value = true
  }

  async function verifyToken(redirect: boolean = true) {
    const response = await $fetch('/api/auth/verify/', {
      method: 'GET',
    })

    isAuthenticated.value = response.authenticated

    if (response.authenticated) {
      await fetchProfile()
    } else {
      logout(redirect)
    }
  }

  // Separate function for middleware that doesn't auto-redirect
  async function checkAuthStatus() {
    const response = await $fetch('/api/auth/verify/', {
      method: 'GET',
    })

    isAuthenticated.value = response.authenticated

    if (response.authenticated) {
      await fetchProfile()
    } else {
      // Only clean state, don't redirect
      isAuthenticated.value = false
      cleanProfile()
    }

    return response.authenticated
  }

  async function logout(redirect: boolean = true) {
    await $fetch('/api/auth/logout/', { method: 'POST' })
    isAuthenticated.value = false
    cleanProfile()
    if (redirect) {
      router.push(localePath('/login'))
    }
  }

  return {
    isAuthenticated,
    login,
    logout,
    verifyToken,
    checkAuthStatus,
  }
}
